var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 38,
    viewBox: "0 0 54 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.19995 35.0601C5.03811 30.3261 11.2584 27.0861 20.963 27.0861C30.6676 27.0861 36.8879 30.3261 39.7261 35.0601M41.5215 23.4964C46.6607 26.066 49.2303 28.6356 51.7999 33.7749M36.1765 3.85543C38.5947 5.15627 40.2386 7.71058 40.2386 10.6488C40.2386 13.5022 38.6883 15.9935 36.3841 17.3264M28.6718 10.6488C28.6718 14.9062 25.2205 18.3576 20.963 18.3576C16.7055 18.3576 13.2542 14.9062 13.2542 10.6488C13.2542 6.39128 16.7055 2.93991 20.963 2.93991C25.2205 2.93991 28.6718 6.39128 28.6718 10.6488Z",
    stroke: "#00A1E4",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/Icon (3).c439ecda3dd00bd12373bf92b67998db.svg";
export { ForwardRef as ReactComponent };